// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>14</span>&nbsp;&nbsp;You water the hills from your dwelling on high;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the earth is filled with the fruit of your works.<br> </p> </div></div>";
// Exports
module.exports = code;